/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MinimumDownpaymentAmount/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AmountOrPercentage from './AmountOrPercentage/index'
import React from 'react'
import Type from './Type/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MinimumDownpaymentAmount({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content/MinimumDownpaymentAmount"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="MinimumDownpaymentAmount.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z178GzR': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 marginTop={0}
 width={150}
 text="Minimum downpayment"
/>
<Type
  viewPath={`${viewPath}/Type`}
/>
<AmountOrPercentage
  viewPath={`${viewPath}/AmountOrPercentage`}
/>
</div>
{children}
</React.Fragment>)
}